import React, { Component, Fragment, useState } from 'react';
import { Row, Col, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import moment from 'moment'; 
import { fetchAPI } from '../../Helpers/FetchAPIWrapper';
import IsLoadingBar from '../isLoading';
import './D365CRM.scss';

const crmURL = 'https://crmreports.ceridian.net/Dynamics365/api';
const timeFormat = 'YYYY-MM-DD, h:mm:ss a';

function IdToWording(name,Id){
    let arr = Array.from(window[name]);
    for(var i = 0; i < arr.length; i++){
        if(arr[i][0] === 'en-'+Id){
            return arr[i][1];
        }
    }
}

export function CaseAttachment({ caseAttachment }) {
    return (<a href={caseAttachment.DownloadLink} download><small>{caseAttachment.File_Name}</small></a>);
}

export function D365CaseDetails({ caseDetails, selectedAccount }){      
    return (
        <Row >
            <Col lg={{ span : 3}}>
                <div className='D365-content-container case-details'>
                    <p><strong>CaseNumber: </strong> <a href={`https://crmreports.ceridian.net/Dynamics365/crm.html#/d365/case/${caseDetails.CRMId}`} target='_blank' rel='noopener noreferrer'>{caseDetails.CaseNumber}</a></p>
                    <p><strong>Created Date:</strong> {moment(caseDetails.CreatedOn).format(timeFormat)}</p>
                    <p><strong>Client:</strong> {caseDetails.Account}</p>
                    <p><strong>Namespace:</strong> {caseDetails.AccNamespace} 
                        <OverlayTrigger
                            placement='top'
                            overlay={
                                <Tooltip>
                                    See namespace details
                                </Tooltip>
                            }>
                            <Button variant='link' className='p-0 m-0 namespace_connector' onClick={() => selectedAccount([caseDetails.AccNamespace])}><i className='fas fa-arrow-circle-right'></i></Button>
                        </OverlayTrigger>
                    </p>
                    <p>
                        <strong>Analyst:</strong> 
                        <a href={`mailto:${caseDetails.AssignedTo && caseDetails.AssignedTo.replaceAll(' ','.') + '@ceridian.com'}`}> {caseDetails.AssignedTo}</a> 
                    </p>
                    <p><strong>Area:</strong> {IdToWording('AreaTr',caseDetails.Area)}</p>
                    <p><strong>Sub Area:</strong> {IdToWording('SubAreaTr',caseDetails.SubArea)}</p>
                    <p><strong>Category:</strong> {IdToWording('CategoryTr',caseDetails.Category)}</p>
                    <p><strong>Severity:</strong> {caseDetails.Priority}</p>
                    <p><strong>TFS: </strong><a href={`https://dev.azure.com/Ceridian/SharpTop/_workcaseDetails#_a=edit&id=${caseDetails.TFSBugNb}`} target='_blank' rel='noopener noreferrer'>{caseDetails.TFSBugNb}</a></p>
                </div>
            </Col>
            
            <Col lg={{ span : 9}}>
                <div className='D365-content-container'>
                    <h6 className='m-0'>{caseDetails.Title}</h6>
                    <div className='mb-2 d365-subtitles'>
                        <small>{caseDetails.Status}</small> | <small>{caseDetails.Origin}</small> | <small>{caseDetails.CurrentQueue}</small>
                    </div>
                    {(caseDetails.Description && caseDetails.Description !== '') ?
                        <p style={{fontSize : '13px'}} dangerouslySetInnerHTML={{ __html : caseDetails.Description }}></p>
                        :
                        <p style={{fontSize : '13px'}}>The description is blank on the case</p>
                    }
                </div>
            </Col>
        </Row>
    );
   
}

export function ActivityBlock({ activity, index, findAttachmentByActivity, activeEmailId, setActiveEmailId, systemActivity }) {

    const caseAttachment = findAttachmentByActivity(activity);
    const attachmentExists = caseAttachment !== null;
    const hasAttachmentFlag = activity.Subject && activity.Subject.indexOf('++') > -1;

    return (
        <Col lg={{ span: 12 }} id={activity.ActivityId} index={index}>
            <div className='D365-content-container case-activity' style={!systemActivity && (activity.CreatedBy === 'SYSTEM' || activity.CreatedBy === 'Ceridian CRM System') ? { display: 'none' } : { display: 'block' }}>
                <h6>
                    <OverlayTrigger
                        placement='top'
                        overlay={
                            <Tooltip className='higher-tooltip'>
                                <span>This comment is by {activity.CreatedBy === 'Customer' ? 'the Customer' : 'Ceridian'}</span>
                            </Tooltip>
                        }
                    >
                        <div className={activity.CreatedBy === 'Customer' ? 'user-icon' : 'staff-icon'}>
                            <i className='fas fa-user'></i>
                        </div>
                    </OverlayTrigger>
                    <p className='activity-title'>{activity.ActivityType}</p>
                </h6>
                <small>{activity.CreatedBy}</small> | <small>{moment(activity.CreatedOn).format(timeFormat)}</small>
                <hr />
                
                {activity.ActivityType === 'Email' ?
                    <div>
                        {activeEmailId === activity.ActivityId ?
                            <div>
                                <Button variant='link' className='p-0' onClick={() => setActiveEmailId(null)}><small>Hide Email</small></Button>
                                <p dangerouslySetInnerHTML={{ __html: activity.Description }}></p>
                            </div>
                            :
                            <div>
                                <Button variant='link' className='p-0' onClick={() =>  setActiveEmailId(activity.ActivityId)}><small>Show Email</small></Button>
                            </div>
                        }
                    </div>
                    :
                    <div>
                        <p dangerouslySetInnerHTML={{ __html: (activity.Description && activity.Description !== null ? activity.Description.replace(/\n/g, '<br />') : activity.Description) }}></p>
                    </div>
                }
                {(hasAttachmentFlag && attachmentExists) && (
                    <CaseAttachment caseAttachment={caseAttachment} />
                )}
            </div>
        </Col>
    );
}

export function D365CaseActivities({ caseActivities, caseAttachments, systemActivity }) {
    caseAttachments = caseAttachments || [];

    const [activeEmailId, setActiveEmailId] = useState(null);

    const findAttachmentByActivity = function (activity) {
        const activityId = activity.ActivityId;
        const firstMatch = caseAttachments.filter((ca) => ca.AttActivityId === activityId)[0];
        return firstMatch || null;
    };

    return (
        <>
            {caseActivities.map((activity, index) => 
                <ActivityBlock activity={activity} index={index} findAttachmentByActivity={findAttachmentByActivity} activeEmailId={activeEmailId} setActiveEmailId={setActiveEmailId} systemActivity={systemActivity} />
            )}
        </>
    );
}

export function D365CaseNotes({ caseNotes }) {
    return (
        <div>
            {caseNotes.map((notes,index) =>                      
                <Col lg={{ span : 12}} key={index}>
                    <div className='D365-content-container case-note'>
                        <h6>{notes.Subject || 'Note'}</h6>
                        <small>{notes.Owner}</small> | <small>{moment(notes.CreatedOn).format(timeFormat)}</small>
                        <hr />
                        <p dangerouslySetInnerHTML={{ __html : notes.NoteText ? notes.NoteText.replace(/\n/g, '<br />') : notes.NoteTextis}}></p>
                        <a href={notes.DownloadLink} download><small>{notes.File_Name}</small></a>
                    </div>
                </Col>      
            )} 
        </div>
    );
}

export default class D365CRM extends Component {    
    constructor(props){
        super(props);

        this.state = {
            D365CRMId : this.props.D365CRMId,
            caseLoading: true,
            isLoading: true,
            isNotes: false,
            caseDetails: null,
            caseActivities: [],
            caseAttachments: [],
            caseNotes: [],
            activitesLoading: true,
            notesLoading: true,        
            showSystemActivity: false
        };
    }

    async componentDidMount() {
        this.getCaseDetails();
        this.getCaseActivities();
        this.getCaseNotes();
    }

    async getCaseDetails() {
        fetchAPI.get(`${crmURL}/D365Case?filter=${this.props.D365CRMId}`)
        .then(caseDetails => {
            this.setState({
                caseDetails : caseDetails,
                namespace: caseDetails.AccNamespace,
                caseLoading: false
            });
            this.getCasePins(caseDetails.CaseNumber);
        }).catch(error => {
            window.apiError(error);
            this.setState({
                isLoading: false
            });
        });
    }

    async getCaseActivities() {
        const self = this;
        fetchAPI.get(`${crmURL}/D365Activity?filter=${this.props.D365CRMId}`)
        .then(activities => {
            if(activities && 'ExceptionMessage' in activities){                       
                this.setState({
                    caseActivities : [{'Subject': 'test', 'Description': 'We are having an issue grabbing this information from D365. Please try again later'}],
                    activitesLoading: false
                }); 
                return;
            }

            this.setState({
                caseActivities : activities,
                activitesLoading: false
            });
            
            for(var i = 0; i < activities.length; i++){
                let caseactivity = activities[i];
                const hasAttachment = caseactivity.Subject && caseactivity.Subject.indexOf('++') > -1;
                if (hasAttachment) {
                    self.getCommentAttachment(caseactivity.ActivityId);
                }
            }

        }).catch(error => {
            window.apiError(error);
            this.setState({
                isLoading: false
            });
        });
    }

    async getCommentAttachment(activityId) {
        
        fetchAPI.get(`${crmURL}/D365Notes?name=portalcommentid&filter=${activityId}`)
        .then(attachments => {
            attachments[0].AttActivityId = activityId;
            this.setState({
                caseAttachments : [...this.state.caseAttachments, attachments[0]]
            });
        }).catch(error => {
            window.apiError(error);
            this.setState({
                isLoading: false
            });
        });
    }

    async getCaseNotes() {
        fetchAPI.get(`${crmURL}/D365Notes?name=incidentid&filter=${this.props.D365CRMId}`)
        .then(notes => {
            this.setState({
                caseNotes : notes,
                notesLoading: false
            });
        }).catch(error => {
            window.apiError(error);
            this.setState({
                isLoading: false
            });
        });
    }

    render(){

        if(this.state.caseLoading){
            return (
                <div id='D365CRM'>
                    <IsLoadingBar alttext={'Fetching case from D365'} customWording={'Fetching case from D365'}  />
                </div>
            );
        }

        return (
            <div id='D365CRM'>
                <Row id='D365CRM-details' className='case-side'>                
                    <Col lg={{span : 12}}>                       
                        <Fragment>
                            <D365CaseDetails caseDetails={this.state.caseDetails} selectedAccount={(account) => this.props.selectedNamespace(account)} />

                            <Row style={{paddingBottom: '35px'}}>
                                <div className='w-100'>
                                    <Button variant='link' className='float-left pl-3' onClick={() => this.setState({showSystemActivity : !this.state.showSystemActivity })}><small>{this.state.showSystemActivity ? 'Hide System Activities' : 'Show System Activities'}</small></Button>
                                    <Button variant='link' className='float-right pl-1' onClick={() => this.setState({isNotes : !this.state.isNotes })}>
                                        {this.state.isNotes ?
                                        <small> Comments <span className='pill'>{this.state.caseActivities.length}</span></small> 
                                        : 
                                        <small> Notes <span className='pill'>{this.state.caseNotes.length}</span></small> 
                                        }
                                    </Button>                              
                                </div>
                                <div className='case-activities w-100'>
                                    {this.state.activitesLoading && (
                                        <IsLoadingBar />
                                    )}
                                    {this.state.isNotes ?
                                         <D365CaseNotes caseNotes={this.state.caseNotes}  />
                                        :

                                        <D365CaseActivities caseActivities={this.state.caseActivities} caseAttachments={this.state.caseAttachments} systemActivity={this.state.showSystemActivity} />
                                    }
                                </div>
                            </Row>  
                        </Fragment>                                      
                    </Col>
                </Row>     
            </div>
       );
    }
}
